"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _common = require("../../common");

var _lib = require("../../lib");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var warning = function warning(func) {
  return console.error("Warning: `keySelector` must be set in <Collection /> before accessing `".concat(func, "()`"));
};

var Collection =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Collection, _PureComponent);

  function Collection(props) {
    var _this;

    _classCallCheck(this, Collection);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Collection).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "findItemIndex", function (arr, item) {
      var keySelector = _this.props.keySelector;

      if (keySelector && Array.isArray(arr)) {
        return arr.findIndex(function (data) {
          return (0, _lib.getSelectorValue)(data, keySelector) === (0, _lib.getSelectorValue)(item, keySelector);
        });
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "checkSelected", function (item) {
      var keySelector = _this.props.keySelector;

      if (keySelector) {
        var selected = _this.state.selected;

        if ((0, _lib.arrayHasItems)(selected)) {
          return selected.some(function (s) {
            return (0, _lib.getSelectorValue)(s, keySelector) === (0, _lib.getSelectorValue)(item, keySelector);
          });
        }
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "checkAllSelected", function () {
      var multiple = _this.props.multiple;
      var _this$state = _this.state,
          data = _this$state.data,
          selected = _this$state.selected;

      if (multiple && (0, _lib.arrayHasItems)(selected)) {
        if ((0, _lib.arrayHasItems)(data)) {
          return data.every(function (item) {
            return selected.indexOf(item) > -1;
          });
        }
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "callOnChange", function (e) {
      var onChange = _this.props.onChange;

      if (onChange) {
        var _this$state2 = _this.state,
            data = _this$state2.data,
            selected = _this$state2.selected;
        onChange(e, {
          data: data,
          selected: selected
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (e, item) {
      (0, _lib.callEventMethods)(e, 'persist');
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          keySelector = _this$props.keySelector;

      if (disabled) {
        (0, _lib.callEventMethods)(e, 'preventDefault');
        return;
      }

      if (!keySelector) {
        warning('onChange');
        return;
      }

      var data = _this.state.data;

      var index = _this.findItemIndex(data, item);

      if (index > -1) {
        data[index] = item;
      }

      _this.setState({
        data: data
      }, function () {
        _this.callOnChange(e);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnSelect", function (e, item) {
      (0, _lib.callEventMethods)(e, 'persist');
      var _this$props2 = _this.props,
          disabled = _this$props2.disabled,
          keySelector = _this$props2.keySelector,
          multiple = _this$props2.multiple;

      if (disabled) {
        (0, _lib.callEventMethods)(e, 'preventDefault');
        return;
      }

      if (!keySelector) {
        warning('onSelect');
        return;
      }

      var selected = _this.state.selected;
      var newSelected = [];

      var index = _this.findItemIndex(selected, item);

      if (multiple) {
        if (index > -1) {
          selected.splice(index, 1);
        } else {
          selected.push(item);
        }

        newSelected = [].concat(selected);
      } else if (index > -1) {
        newSelected = [];
      } else {
        newSelected = [item];
      }

      _this.setState({
        selected: newSelected
      }, function () {
        _this.callOnChange(e);

        var onSelect = _this.props.onSelect;

        if (onSelect) {
          onSelect(item);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnSelectAll", function (e) {
      var checked = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      (0, _lib.callEventMethods)(e, 'persist');
      var _this$props3 = _this.props,
          disabled = _this$props3.disabled,
          keySelector = _this$props3.keySelector,
          multiple = _this$props3.multiple;

      if (disabled) {
        (0, _lib.callEventMethods)(e, 'preventDefault');
        return;
      }

      if (!multiple) {
        return;
      }

      if (!keySelector) {
        warning('onSelectAll');
        return;
      }

      var selected = _this.state.selected;
      var data = _this.state.data;

      if (checked) {
        data.forEach(function (item) {
          var index = _this.findItemIndex(selected, item);

          if (index < 0) {
            selected.push(item);
          }
        });
      } else {
        selected = selected.filter(function (item) {
          return !data.includes(item);
        });
      }

      var newSelected = [].concat(selected);

      _this.setState({
        selected: newSelected
      }, function () {
        _this.callOnChange(e);

        var onSelectAll = _this.props.onSelectAll;

        if (onSelectAll) {
          onSelectAll(checked, newSelected);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnAdd", function (e, item) {
      (0, _lib.callEventMethods)(e, 'persist');

      if (_this.props.disabled) {
        (0, _lib.callEventMethods)(e, 'preventDefault');
        return;
      }

      if (item) {
        var data = _this.state.data;

        if ((0, _lib.arrayHasItems)(item)) {
          data = data.concat(item);
        } else {
          data.push(item);
        }

        var newData = [].concat(data);

        _this.setState({
          data: newData
        }, function () {
          _this.callOnChange(e);

          var onAdd = _this.props.onAdd;

          if (onAdd) {
            onAdd(item);
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnDelete", function (e, item) {
      (0, _lib.callEventMethods)(e, 'persist');
      var _this$props4 = _this.props,
          disabled = _this$props4.disabled,
          keySelector = _this$props4.keySelector;

      if (disabled) {
        (0, _lib.callEventMethods)(e, 'preventDefault');
        return;
      }

      if (!keySelector) {
        warning('onDelete');
        return;
      }

      var data = _this.state.data;

      if ((0, _lib.arrayHasItems)(data)) {
        var index = _this.findItemIndex(data, item);

        if (index > -1) {
          data.splice(index, 1);
          var newData = [].concat(data);

          _this.setState({
            data: newData
          }, function () {
            _this.callOnChange(e);

            var onDelete = _this.props.onDelete;

            if (onDelete) {
              onDelete(item);
            }
          });
        }
      }
    });

    var _data = props.data,
        _selected = props.selected;
    _this.state = {
      prevProps: {
        data: _data,
        selected: _selected
      },
      data: (0, _lib.arrayHasItems)(_data) ? [].concat(_data) : [],
      selected: (0, _lib.arrayHasItems)(_selected) ? [].concat(_selected) : []
    };
    return _this;
  }

  _createClass(Collection, [{
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          children = _this$props5.children,
          disabled = _this$props5.disabled;
      var _this$state3 = this.state,
          data = _this$state3.data,
          selected = _this$state3.selected;
      var isSelectedAll = this.checkAllSelected();
      return (0, _lib.getRenderProps)(children, {
        data: data,
        selected: selected,
        disabled: disabled,
        onChange: this.handleOnChange,
        onSelect: this.handleOnSelect,
        onSelectAll: this.handleOnSelectAll,
        onAdd: this.handleOnAdd,
        onDelete: this.handleOnDelete,
        isSelected: this.checkSelected,
        isSelectedAll: isSelectedAll,
        findItemIndex: this.findItemIndex
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps; // Compare the incoming prop to previous prop

      var data = props.data,
          selected = props.selected,
          multiple = props.multiple;
      var newSelected = prevProps.selected !== selected ? [].concat(selected) : state.selected;

      if (!multiple && prevProps.data !== data && (0, _lib.arrayHasItems)(newSelected) && !newSelected.every(function (item) {
        return data.indexOf(item) > -1;
      })) {
        // clear selected when data don't have selected item
        newSelected = [];
      }

      return {
        // Store the previous props in state
        prevProps: {
          data: data,
          selected: selected
        },
        data: prevProps.data !== data ? [].concat(data) : state.data,
        selected: newSelected
      };
    }
  }]);

  return Collection;
}(_react.PureComponent);

exports["default"] = Collection;

_defineProperty(Collection, "displayName", 'Collection');

_defineProperty(Collection, "propTypes", {
  data: _propTypes["default"].arrayOf(_propTypes["default"].any).isRequired,
  selected: _propTypes["default"].arrayOf(_propTypes["default"].any),
  children: _common.customPropTypes.render.isRequired,
  onChange: _propTypes["default"].func,
  onSelect: _propTypes["default"].func,
  onSelectAll: _propTypes["default"].func,
  onAdd: _propTypes["default"].func,
  onDelete: _propTypes["default"].func,
  disabled: _propTypes["default"].bool,
  keySelector: _common.customPropTypes.as,
  multiple: _propTypes["default"].bool
});

_defineProperty(Collection, "defaultProps", {
  selected: [],
  onChange: null,
  onSelect: null,
  onSelectAll: null,
  onAdd: null,
  onDelete: null,
  disabled: false,
  keySelector: null,
  multiple: true
});